<template>
  <div :class="classes" v-loading="customerLoading">
      <pt-page-title title="奖励发放"></pt-page-title>
      <table :class="$style['reward-grant-table']">
       <pt-form-list-item label="发放对象：" required @widthItem="widthItem">
         <select-user-fitter fromPage="promotion-form" :isReward="true" :showBetchSelectUser="false" :selectUserList="selectUserList" :isShowTxt="false"
          @userSubmit="userSubmit" :disableSelect="disableSelect" @importLoading="importLoading">
         </select-user-fitter>
            <!-- <el-button type="primary" @click="selectUser" plain>点击选择</el-button>
            <div :class="$style['select-user-name']" v-if="selectUserList&&selectUserList.length">
                    <span>已选择 {{firstUserName}} {{selectUserList.length > 1 ? ('等'  +selectUserList.length +'位用户...') : ''}}</span>
                    <el-button type="text" @click="view_user">查看</el-button>
                </div> -->
        </pt-form-list-item>
      </table>
        <customer-grant-form :isFinancial="isFinancial" :fromType="fromType" @changeBusinessType="changeBusinessType" :max-width="maxWidth" :bussinessTypeLoading="bussinessTypeLoading" v-model="grantMessage"
        ref="customerGrantForm" :bussinessTypes="bussinessTypes" @getRewardBusinessType="getRewardBusinessType" :business-departments="businessDepartments" :department-loading="departmentLoading"></customer-grant-form>
    <el-dialog :visible.sync="is_dialog" :title="dialog_title" @close="closeDialog" :class="(is_select_user||is_view_user)?$style['user-dialog']:''">
        <select-for-user :pageSize="5" v-if="is_select_user" @selectUsersSubmit="selectUsersSubmit" :selectedUser="JSON.parse(JSON.stringify(selectUserList))"  @close="closeDialog"></select-for-user>
        <select-view-user v-if="is_view_user" :userIds="formValue.userIds" @viewUserListDelete="viewUserListDelete" :pageEdit="true"  @close="closeDialog"></select-view-user>
        <coupon-list v-if="is_select_coupon" @selectCouponSubmit="selectCouponSubmit"  @close="closeDialog" :selected-coupon="coupon_list"></coupon-list>
    </el-dialog>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import customerGrantForm from 'cps/mall-manage/pt-old-to-new/pt-batch-grant/customer-grant-form'
import selectForUser from 'cps/customer-manage/select-for-user'
import selectViewUser from 'cps/customer-manage/select-view-user.vue'
import { cashCount } from '@/utils/formUtils'
import selectUserFitter from 'cps/base/select-user-fitter/index'
import { hasPermissions } from 'utils/permissions'
// 组件class前缀
const prefixCls = 'pt-reward-grant-form'

export default {
  name: 'pt-reward-grant-form',
  mixins: [formMixins],
  components: {
    customerGrantForm,
    selectForUser,
    selectViewUser,
    selectUserFitter
  },
  props: {
    bussinessTypes: {
      type: Array,
      default: function () {
        return []
      }
    },
    fromType: {
      type: String,
      default: null
    },
    bussinessTypeLoading: {
      type: Boolean,
      default: false
    },
    businessDepartments: {
      type: Array
    },
    departmentLoading: Boolean
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_select_user || this.is_view_user || this.is_select_coupon
      },
      set: function (val) {
        this.is_select_user = val
        this.is_view_user = val
        this.is_select_coupon = val
      }
    },
    form () {
      return this.$refs.customerGrantForm
    },
    hasFinancial () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, 'PERM_FINANCIAL_REWARD')
    }
  },
  data () {
    return {
      formValue: {

      },
      is_select_user: false,
      is_view_user: false,
      is_select_coupon: false,
      selectUserList: [],
      dialog_title: '',
      firstUserName: null,
      maxWidth: null,
      grantMessage: {},
      disableSelect: false,
      customerLoading: false,
      isFinancial: false
    }
  },
  watch: {
    selectUserList: {
      handler: function (val) {
        if (val) {
          this.formValue.userIds = []
          val.forEach(item => {
            this.formValue.userIds.push(item.id ? item.id : item)
          })
        }
      },
      deep: true
    },
    grantMessage: {
      handler: function (val) {
        this.formValue = { ...this.formValue, ...val }
        this.formValue.money = val.amount && cashCount(val.amount)
        this.$delete(this.formValue, 'amount')
      },
      deep: true
    }
  },
  methods: {
    importLoading (val) {
      this.customerLoading = val
    },
    userSubmit (val) {
      if (val && val.userListId) {
        this.disableSelect = true
        let mallUserCriteria = {
          mallUserCriteria: {
            whiteList: [
              {
                userListId: val.userListId
              }
            ]

          }
        }
        this.formValue = { ...this.formValue, ...mallUserCriteria, ...val }
        this.$delete(this.formValue, 'userListId')
        // if (this.formValue.userIds) {
        //   this.$delete(this.formValue, 'userIds')
        // }
      } else {
        this.formValue = { ...this.formValue, ...val }
      }
      if (val.ids) {
        this.$set(this.formValue, 'userIds', val.ids)
        this.$delete(this.formValue, 'ids')
      }
      if (this.formValue && this.formValue.mallUserCriteria && this.formValue.mallUserCriteria.whiteList && this.formValue.mallUserCriteria.whiteList.length) {
        this.isFinancial = true
      }
    },
    changeBusinessType (val) {
      this.$emit('changeBusinessType', val)
    },
    getRewardBusinessType () {
      this.$emit('getRewardBusinessType')
    },
    widthItem (val) {
      this.maxWidth = val
    },
    view_user () {
      this.dialog_title = '查看用户'
      this.is_view_user = true
    },
    selectUser () {
      this.dialog_title = '选择用户'
      this.is_select_user = true
    },
    closeDialog () {
      this.is_dialog = false
    },
    selectUsersSubmit (val) {
      this.is_select_user = false
      let firstUserName = ''
      for (let i in val) {
        if (val[i].fullName) {
          firstUserName = val[i].fullName
          break
        }
      }
      this.selectUserList = val
      this.firstUserName = firstUserName
    },
    viewUserListDelete (val) {
      this.selectUserList = JSON.parse(JSON.stringify(val))
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.reward-grant-table{
    padding: 0 20px
}
.user-dialog{
    :global
    .el-dialog{
        width: 70%;
        min-width: 1000PX;
        max-width:1200Px;
    }
    :global
    .el-dialog__body{
     padding: 0 20px 30px;
    }
}
</style>
